import { FilePreUploadParams, WFile } from "@/types/file";
import request, { BASEURL } from ".";
import { isFile, isString, isStringEmpty } from "@/utils/checkTool";
import { cleanToFile } from "@/utils/cleanData";
import { isArray } from "lodash";

const FILE_URL = "/files";

export const getFileUrl = (fileId: string) => {
  if (!fileId) return
  return `${BASEURL + FILE_URL}/${fileId}/get`;
};
export const getFileInfo = (fileId: string, wmsApi?: string) => {
  if (!fileId) return
  return new Promise<WFile>((resolve, reject) => {
    request<WFile, undefined>(`${FILE_URL}/${fileId}/info/get`, { requestConfig: { baseURL: wmsApi } })
      .then(res => resolve(res.body))
      .catch(err => reject(err))
  })
};

export const downloadFileUrl = (fileId: string, wmsApi?: string) => {
  if (!fileId) return
  return `${(wmsApi || BASEURL) + FILE_URL}/${fileId}/download`;
};

export const downloadFileUrlBatch = (fileIds: string[], wmsApi?: string) => {
  if (!!!fileIds.length) return
  return `${(wmsApi || BASEURL) + FILE_URL}/${fileIds.join(',')}/export`;
};

export const exportFileUrl = (fileId: string) => {
  if (!fileId) return
  return `${BASEURL + FILE_URL}/${fileId}/export`;
};

const FILE_APIS = {
  preupload: FILE_URL + `/preupload`,
  upload: (partId: string) => FILE_URL + `/part/${partId}/upload`,
  files: (id: string) => FILE_URL + `/${id}/files`,
  // delFile: (id: string) => FILE_URL + `/${id}/del`,
};

export const preuploadFile = (fileInfo: FilePreUploadParams, wmsApi?: string) => {
  return request<WFile, FilePreUploadParams>(FILE_APIS.preupload, {
    params: { body: fileInfo },
    requestConfig: { baseURL: wmsApi }
  })
    .then(({ body: file }) => {
      if (isFile(file)) {
        return Promise.resolve(cleanToFile(file));
      } else {
        return Promise.reject(10013);
      }
    })
    .catch((err) => Promise.reject(err));
};

export const uploadFile = (id: string, fileInfo: FormData, wmsApi?: string) => {
  if (!isString(id) || isStringEmpty(id)) {
    return Promise.reject(10012);
  }
  return request<WFile, any>(FILE_APIS.upload(id), {
    params: fileInfo,
    requestConfig: { baseURL: wmsApi }
  })
    .then(({ body: files }) => {
      if (isArray<WFile>(files)) {
        return Promise.resolve(files.filter(file => isFile(file))?.map(file => cleanToFile(file)));
      } else {
        return Promise.reject(10013);
      }
    })
    .catch((err) => Promise.reject(err));
};

export const uploadFileState = (id: string, wmsApi?: string) => {
  if (!isString(id) || isStringEmpty(id)) {
    return Promise.reject(10012);
  }
  return request<WFile>(FILE_APIS.files(id), { requestConfig: { baseURL: wmsApi } })
    .then(({ body: file }) => {
      if (isFile(file)) {
        return Promise.resolve(cleanToFile(file));
      } else {
        return Promise.reject(10013);
      }
    })
    .catch((err) => Promise.reject(err));
};

// export const delFile = (id: string) => {
//   return new Promise<void>((resolved, rejected) => {
//     request<void, undefined>(FILE_APIS.delFile(id))
//       .then(() => resolved())
//       .catch(err => rejected(err))
//   })
// }